<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="3" viewBox="0 0 14 3" fill="none">
    <line x1="1.85938" y1="1.5" x2="12.5" y2="1.5" stroke="black" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>
